module.exports = "\n<div class=\"wrapper container-fluid clearfix\">\n\n  <main-header></main-header>\n\n  <div ui-view=\"mainContent\"></div>\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/layout/main-layout/main-layout.html
// module id = 384
// module chunks = 0